import React from 'react';
import { object, string, number, array } from 'yup';
import OtherIncomes from '../IncomeDetailsComponent/OtherIncomes_Salaried/OtherIncomes_Salaried';
import ProfessionDetails from '../IncomeDetailsComponent/ProfessionDetails';
import ChooseProfession from '../IncomeDetailsComponent/ChooseProfession';
import PersonalDetails from '../PersonalDetails/PersonalDetails';
import Form16 from '../IncomeDetailsComponent/Form16/Form16';
import OtherSavings from '../IncomeDetailsComponent/OtherSaving/OtherSaving';
import AddSalary from '../IncomeDetailsComponent/SalaryDetails/AddSalary';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import { addProfession, saveOthersSaving } from '../../../common/constants/api';
import SuccessPopUP from '../../UserKyc/UserPopUP/IncomeSuccessPopUp';
import IncomeStarterScreen from '../../../common/components/IncomeStarterScreen/IncomeStarterScreen';
import initialImg from '../../../images/icons/KYCComplete.svg';
import loanImg from '../../../images/icons/loan-obligation.svg';
let viewAccount = false;
import AddLoan from '../LoanDetails/AddLoan';

export const isViewAccount = () => {
  return viewAccount;
};

let Steps = [
  {
    id: 'ProfessionDetails',
    component: ProfessionDetails,
    initialValues: {
      fileRef: true,
      file: [],
      imgUrl: [],
      qualification: {
        label: 'Select Highest Qualification',
        value: ''
      },
      companyName: '',
      companyType: '',
      department: '',
      designation: '',
      industry: {
        label: 'Choose Industry',
        value: ''
      },
      email: '',
      totalExperienceYear: {
        label: 'year',
        value: ''
      },
      gstCheck: false,
      gstNo: '',
      totalExperienceMonth: {
        label: 'Month',
        value: ''
      },

      currentCompanyExperienceYear: {
        label: 'year',
        value: ''
      },
      currentCompanyExperienceMonth: {
        label: 'Month',
        value: ''
      }
    },
    validationSchema: object().shape({
      file: array().when('fileRef', {
        is: true,
        then: array()
          .min(2, 'please both the file ')
          .required('file is required')
          .of(string().required())
      }),
      imgUrl: string().when('fileRef', {
        is: true,
        then: string().required('file is required')
      }),
      qualification: object().shape({
        value: string().required('Required')
      }),
      companyName: string().required('Required'),
      companyType: object().shape({
        value: string().required('Required')
      }),
      gstNo: string()
        .trim()
        .matches(
          /[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
          'Please enter valid GST number.'
        ),
      industry: object().shape({
        value: string().required('Required')
      }),

      email: string()
        .email('Please enter email address')
        .max(50, 'Email address is Too Long!')
        .required('Required')
        .matches(
          /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
          'invalid type'
        ),

      totalExperienceYear: object().shape({
        value: string().required('Required')
      }),

      totalExperienceMonth: object().shape({
        value: string().required('Required')
      }),

      currentCompanyExperienceYear: object().shape({
        value: string().required('Required')
      }),

      currentCompanyExperienceMonth: object().shape({
        value: string().required('Required')
      })
    }),
    onAction: async (sectionValues, formValues) => {}
  },

  {
    id: 'form16',
    component: Form16,
    initialValues: {
      file: [],
      imgUrl: []
    },
    validationSchema: object().shape({}),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'AddSalary',
    component: AddSalary,
    initialValues: {
      professionType: '',
      file: [],
      imgUrl: [],
      accountNo: '',
      ifscCode: '',
      statementType: '',
      viewAccount: isViewAccount,
      addNewAccount: true
    },
    validationSchema: object().shape({
      accountNo: string().when('addNewAccount', {
        is: true,
        then: string()
          .required('Required')
          .min(9, 'Account Number Must be minimum 9 digits')
          .max(18, 'Account Number should not excced 18 digits')
      }),
      ifscCode: string().when('addNewAccount', {
        is: true,
        then: string()
          .required('Required')
          .matches(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/, 'Invalid IFSC code Format')
      }),

      statementType: string().when('addNewAccount ', {
        is: true,
        then: string().required('Required')
      })
    }),

    onAction: (sectionValues, formValues) => {
      console.log('i am sectionvalue', sectionValues);
    }
  },

  {
    id: 'otherIncomes',
    component: OtherIncomes,
    initialValues: {
      file: [],
      imgUrl: [],
      intFromDeposit: false,
      bankInt: false,
      rentalIncome: false,
      agriIncome: false,
      divident: false
    },
    validationSchema: object().shape({}),
    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'otherSaving',
    component: OtherSavings,
    initialValues: {
      gold: false,
      mutualFunds: false,
      pF: false,
      fD: false,
      uL: false,
      fA: false
    },
    validationSchema: object().shape({}),
    onAction: async (sectionValues, formValues) => {
      let data = getApplicantionInfo();
      const { leadId, leadApplicantId } = data;
      await saveOthersSaving(leadId, leadApplicantId, {
        isGold: sectionValues.gold,
        isMutualFund: sectionValues.mutualFunds,
        isPf: sectionValues.pF,
        isFdOrRd: sectionValues.fD,
        isUlOrIp: sectionValues.uL,
        isFixedAssests: sectionValues.fA
      })
        .then(res => console.log(res))
        .catch(err => {
          throw new Error(
            err?.response?.data?.message ||
              'something went wrong please try again. .'
          );
        });
    }
  },
  {
    id: 'AddLoan',
    component: AddLoan,
    initialValues: {
      file: [],
      imgUrl: [],
      lender: '',
      loanType: '',
      sanctionAmount: '',
      balanceAmount: '',
      totalTenure: '',
      balanceTenure: '',
      sanctionDocId: null,
      statementDocId: null,
      viewAccount: isViewAccount,
      addNewLoan: true
    },
    validationSchema: object().shape({
      lender: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      loanType: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      sanctionAmount: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      balanceAmount: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      totalTenure: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      currentEmi: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      }),
      balanceTenure: string().when('addNewLoan', {
        is: true,
        then: string().required('Required')
      })
    }),
    onAction: (sectionValues, formValues) => {
      console.log('i am sectionvalue', sectionValues);
    }
  },
  {
    id: 'PersonalDetails',
    component: PersonalDetails,
    initialValues: {
      maritalStatus: {
        label: 'Marital Status',
        value: ''
      },
      religion: {
        label: 'Religion',
        value: ''
      },

      category: {
        label: 'Category',
        value: ''
      },
      residential: {
        label: 'Residential Status',
        value: ''
      },
      file: [],
      imgUrl: []
    },
    validationSchema: object().shape({
      maritalStatus: object().shape({
        value: string().required('Required')
      }),
      religion: object().shape({
        value: string().required('Required')
      }),
      category: object().shape({
        value: string().required('Required')
      }),
      residential: object().shape({
        value: string().required('Required')
      })
    }),

    onAction: (sectionValues, formValues) => {}
  },
  {
    id: 'SuccessPopUP',
    component: SuccessPopUP
  }
];
export default Steps;
